import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'

type Props = { children: ReactNode }
type State = { error: Error | null }
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null }
  static getDerivedStateFromError(error: Error): State { return { error } }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('route render failed', error, info) }
  render() {
    if (!this.state.error) return this.props.children
    return <div className="mx-auto flex max-w-lg flex-col items-center gap-4 py-24 text-center"><AlertTriangle className="h-10 w-10 text-warning" /><h1 className="text-xl font-semibold">页面暂时无法加载</h1><p className="text-sm text-muted-foreground">该模块出现了意外错误。返回总览后可以继续其他研究工作。</p><div className="flex gap-2"><Button onClick={() => this.setState({ error: null })} variant="outline">重试</Button><Link to="/" className="inline-flex h-9 min-h-11 items-center justify-center rounded-md border border-primary bg-primary px-3 text-sm font-medium text-primary-foreground md:min-h-0">返回总览</Link></div></div>
  }
}
